var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DataTableDisplay"},[_c('DataTable',{attrs:{"data":_vm.getData,"headers":_vm.headers,"withPagination":""},on:{"rowClick":_vm.navigateToItem},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
var header = ref.header;
return [_c('TableField',{attrs:{"data":row,"header":header}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }